import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip } from 'components';
import { ClientQuoteService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { connect } from 'react-redux';
import { GoogleMapsIcon, PinIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
	surcharge_title?: string;
	conversion?: number;
}

declare var window: any;

// @ts-ignore
const google = window.google;

class ModalConfirm extends React.Component<Props> {

	state = {
		item: this.props.item,
		conditions: false
	}

	componentDidMount() {
		if (google && this.state.item?.latitude && this.state.item?.longitude) {
			this.setMap();
		}
	}

	setMap = async () => {
		const map = new google.maps.Map(document.getElementById('map-view-quote'), {
	      zoom: 13,
	      center: new google.maps.LatLng(this.state.item?.latitude,this.state.item?.longitude),
	      draggable: true,
	      zoomControl: true,
	      streetViewControl: false,
	      fullscreenControl: false,
	      scaleControl: false,
	      rotateControl: false
	    });

	    const marker = new google.maps.Marker({
	      position: new google.maps.LatLng(this.state.item?.latitude,this.state.item?.longitude),
	      map,
	      title: 'Ubicación',
	      animation: google.maps.Animation.DROP,
	      draggable: false,
	      icon: PinIcon
	    });

	    marker.addListener('click',() => {
	    	window.open(`https://maps.google.com/?q=${ this.state.item?.latitude },${ this.state.item?.longitude }`);
		});
	}

	submit = async () => {
		if (!this.state.conditions) {
			Globals.showError("Debe aceptar los términos y condiciones para continuar");
			return;
		}
		this.props.onClose(true);
	}

	conditions = (e: any, url: string) => {
		if (window.webkit && window.webkit.messageHandlers) {
			e.preventDefault();
			const message = 'open_url';
			const sendToNative = {
				message,
				url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	} 
	
	render() {
		const { item } = this.state;
		const { city } = this.state.item;
		const address = [city].filter((i: any) => i != null && i != '').join(' - ');
		let date = moment(item.date).format('DD/MM/YYYY');

		if (item.multiples_dates && item.days_selected.length > 0) {
			date = item.days_selected.map((item: string) => moment(item).format('DD/MM/YYYY')).join(' - ');
		}

		const quantity_of_days = this.state.item.multiples_dates ? this.state.item.days_selected.length : 1;

		return (
			<div id="modal-quotes-view">
				<div className="row row-blue">
					<div className="col-md-6">
						<p><strong>Cliente: </strong> { item?.user?.full_name }</p>
						<p><strong>Teléfono: </strong> { item?.user?.phone }</p>
						<p><strong>RIF / C.I.:</strong> { [Constants.DOCUMENT_TYPES.V,Constants.DOCUMENT_TYPES.E].indexOf(item?.user?.document_type_id) != -1 ? item?.user?.full_document : item?.user?.full_tax_document }</p>
					</div>
					<div className="col-md-6 container-right">
						<p className={ `text-right ${ item?.type_id == Constants.QUOTE_TYPES.URGENT.toString() ? 'urgent' : '' }` }>{ item?.type_id == Constants.QUOTE_TYPES.URGENT.toString() ? ('Urgente ' + date) : date }</p>
						<p className="text-right">{ moment(item.journey?.since,'HH:mm:ss').format('hh:mm a') } - { moment(item.journey?.until,'HH:mm:ss').format('hh:mm a') }</p>
					</div>
				</div>
				<div className="row row-service">
					<div className="col-md-6">
						<p><strong>Servicio: </strong> { item?.service?.name }</p>
						{
							item?.accessories && JSON.parse(item?.accessories).length > 0 && (
								<p><strong>Complementos:</strong> { JSON.parse(item?.accessories).map((i: any) => i.name).join(', ') }</p>
							)
						}
						<p><strong>Superficie/Cantidad: </strong> { item?.area }</p>
						{
							item.surcharges > 0 && (
								<p><strong>{ this.props.surcharge_title }:</strong> { Globals.formatMiles(item.surcharges,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion || 0) }</p>
							)
						}
						{
							item.journey_surcharge > 0 && (
								<p><strong>Recargo por Jornada:</strong> { Globals.formatMiles(item.journey_surcharge,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion || 0) }</p>
							)
						}
					</div>
					<div className="col-md-6 text-right">
						{
							(item.price) && (
								<React.Fragment>
									<p className="price-title">Costo</p>
									<p className="price">{ Globals.formatMiles(((item.price) * quantity_of_days) + item.surcharges + item.journey_surcharge,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion || 0) }</p>
								</React.Fragment>
							) || ''
						}
					</div>
				</div>
				{
					item.discount && (
						<div className="row row-service">
							<div className="col-md-6">
								<p><strong>Código de descuento: </strong> { item?.discount?.code }</p>
								<p><strong>Descuento: </strong> { item?.discount?.percent }%</p>
							</div>
							<div className="col-md-6 text-right">
								<p className="price-title">Total</p>
								<p className="price">{ Globals.formatMiles(item.price,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion || 0) }</p>
							</div>
						</div>
					)
				}
				<div className="container-padding-address">
					{
						(city) && (
							<React.Fragment>
								<div className="container-title">
									<img src={ GoogleMapsIcon } />
									<p>Dirección</p>
								</div>
								<p>{ address }</p>
							</React.Fragment>
						)
					}
					
					{
						this.state.item?.latitude && this.state.item?.longitude && (
							<div id="map-view-quote"></div>
						)
					}
					{
						item?.comments && (
							<div className="comments">
								<div className="container-title">
									<p>Descripción</p>
								</div>
								<p>{ item?.comments }</p>
							</div>
						)
					}
				</div>

				<div className="item-terms">
					<CheckboxTable 
						active={ this.state.conditions } 
						onClick={ () => this.setState({
							conditions: !this.state.conditions
						}) } />	
					<p>Al solicitar una cita acepta los <a target="_blank" onClick={ (e: any) => this.conditions(e,Constants.BASE_PUBLIC + 'files/conditions.pdf') } href={ Constants.BASE_PUBLIC + 'files/conditions.pdf' }>términos y condiciones</a></p>
				</div>

				<div className="text-center">
					<button className="btn btn-green" onClick={ () => this.submit() }>
						Aceptar
					</button>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		surcharge_title: state.surcharge_title
	}
})(ModalConfirm);